// extracted by mini-css-extract-plugin
export var about = "Sidebar-module--about--2e2ae";
export var active = "Sidebar-module--active--c124c";
export var contact = "Sidebar-module--contact--24a51";
export var navLabel = "Sidebar-module--navLabel--545ea";
export var open = "Sidebar-module--open--86d3b";
export var projects = "Sidebar-module--projects--31098";
export var sidebar = "Sidebar-module--sidebar--1bfa1";
export var skills = "Sidebar-module--skills--97689";